@let view = data();

@if (view.image) {
  <ui-image [data]="view.image"></ui-image>
}
